<template>
  <div class="flex-1">
    <div class="flex items-center">
      <v-text-field
        v-model.trim="actions[actionName]"
        class="mx-2"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        :placeholder="placeholder"
        :disabled="disabled"
        bgColor="#fff"
        hideDetails
      />
      <RfInsertUserTrait
        :actionName="actionName"
        :app="app"
        title="redirect"
        :actions="actions"
        noSpace
      />
    </div>
    <div
      v-if="!disabled && ['accept', 'accept2', 'decline'].includes(interactionType)"
      class="flex w-full justify-end"
    >
      <v-checkbox
        v-model="actions[keepOpenActionName]"
        hideDetails
        density="compact"
        trueValue="true"
        falseValue="false"
      >
        <template #label>
          <span class="text-grey-1 text-sm">Keep prompt open when redirecting</span>
          <v-tooltip
            text="Ensure the prompt remains open if the user navigates back"
            location="bottom"
          >
            <template #activator="{ props }">
              <v-icon v-bind="props" size="18" class="text-grey-2 ml-1">md:info</v-icon>
            </template>
          </v-tooltip>
        </template>
      </v-checkbox>
    </div>
    <RfFadeTimer
      v-if="!disabled"
      v-model:fadeTimer="actions[delayActionName]"
      title="Redirect Delay (optional)"
    />
  </div>
</template>

<script>
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import RfFadeTimer from "@/components/RfPathCreate/RfRetentionActions/RfFadeTimer.vue";
import { redirectDelayActionName } from "@/utils/prompts/promptActionHelpers";

export default {
  name: "RfRetentionConnectorWebsiteActionRedirect",
  components: { RfInsertUserTrait, RfFadeTimer },
  provide: () => ({ [Symbol.for("vuetify:selection-control-group")]: null }),
  props: {
    actions: { type: Object, required: true },
    actionName: { type: String, required: true },
    app: { type: Object, required: true },
    interactionType: { type: String, required: true },
    placeholder: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    keepOpenActionName() {
      return `rf_settings_${this.interactionType}_redirect_keep_open`;
    },
    delayActionName() {
      return redirectDelayActionName(this.interactionType);
    },
  },
};
</script>
